function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#fab400",
    style: {
      fill: "var(--color1, #fab400)"
    },
    d: "M24 17.5h-24v4h24v-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c2f76",
    style: {
      fill: "var(--color2, #1c2f76)"
    },
    d: "M24 2.5h-24v4h24v-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c2f76",
    style: {
      fill: "var(--color2, #1c2f76)"
    },
    d: "M9.607 9.246l-2.48 6.207h-1.617l-1.22-4.955c-0.074-0.303-0.139-0.416-0.364-0.54-0.368-0.21-0.975-0.407-1.508-0.529l0.036-0.18h2.603c0.17 0 0.334 0.063 0.463 0.179s0.215 0.275 0.243 0.451l0.645 3.593 1.591-4.228 1.609 0.002zM15.944 13.428c0.007-1.638-2.159-1.729-2.143-2.46 0.005-0.222 0.207-0.461 0.648-0.521 0.518-0.052 1.040 0.044 1.51 0.278l0.267-1.317c-0.458-0.18-0.942-0.273-1.431-0.275-1.513 0-2.576 0.845-2.585 2.054-0.009 0.893 0.76 1.391 1.339 1.689 0.6 0.304 0.797 0.498 0.794 0.771 0 0.416-0.476 0.601-0.915 0.608-0.771 0.012-1.216-0.219-1.572-0.393l-0.278 1.36c0.358 0.174 1.018 0.323 1.701 0.33 1.608 0 2.657-0.833 2.665-2.124h-0.001zM19.939 15.455h1.414l-1.236-6.207h-1.306c-0.14-0.001-0.277 0.042-0.393 0.123s-0.206 0.198-0.259 0.334l-2.296 5.752h1.608l0.319-0.927h1.963l0.186 0.926zM18.23 13.255l0.806-2.332 0.464 2.332h-1.269zM11.793 9.246l-1.265 6.207h-1.529l1.264-6.207h1.53z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.9d468dba03179527b330d9feb21920a0.svg";
export { ForwardRef as ReactComponent };